<template>
    <ul id="item-body">
        <template v-for="(item, index) in datalist" class="link-message">
            <li :key="index" class="link-message" @click="openWorkFlow(item)">
                <div class="item">
                    <div class="title">
                        <div class="msg">
                            <div>{{ item.flVehPlate }}</div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="name1">
                            {{ item.flStartTime | CreateData }}&nbsp;&nbsp;
                            <span v-text-lbl="'common.to'">至</span>
                            &nbsp;&nbsp;{{ item.flEndTime | CreateData }}
                        </div>
                        <div>{{ carStatus(item.status) }}</div>
                    </div>
                    <div class="bottom">
                        <div class="name1">{{ item.flDst }}</div>
                        <div>{{ draveType(item.draveType) }}</div>
                    </div>
                </div>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    filters: {
        CreateData(val) {
            const moment = require('moment')
            return moment(val).format('MM-DD HH:mm')
        }
    },
    props: {
        datalist: {
            type: Array,
            default: function () {
                return []
            }
        },
        appletData: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        }
    },
    data() {
        return {}
    },
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
        if (this.clearInterval !== null) clearInterval(this.timeInterval)
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {
        // 车辆状态
        carStatus(val) {
            const list = [this.$tx('clgl.portlet.AlreadyBooked', '已预约'), this.$tx('clgl.portlet.PendingVehicle', '待派车'), this.$tx('clgl.portlet.SentCar', '已派车'), this.$tx('clgl.portlet.OutCar', '出车中'), this.$tx('clgl.portlet.ReturnedCar', '已还车'), this.$tx('clgl.portlet.Rejected', '已拒绝'), '', '', '', this.$tx('clgl.portlet.Cancelled', '已取消')]
            return list[val]
        },
        // 驾车方式
        draveType(val) {
            switch (val) {
                case 1:
                    return this.$tx('clgl.portlet.AccompanyDriver', '随车司机')
                default:
                    return this.$tx('clgl.portlet.SelfDriving', '自驾')
            }
        },
        openWorkFlow(row) {
            const search = this.$vnode.context.$vnode.context.appletData.url.split('?')[1]
            this.$bus.emit('redirectMoreClick', search.split('=')[1], 'mySendcar')
        }
    } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
#item-body {
    width: 100%;
    height: 100%;
    padding-left: 0;
    margin: 0;
    .link-message {
        width: 100%;
        // height: 100px;
        font-size: var(--portalFontSize14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        padding-left: 20px;
        list-style: none;
        border-bottom: 1px solid #eee !important;
        .item {
            padding: 10px 20px 10px 0;
            width: 100%;
            height: 100%;
            //border-bottom:1px dashed #EBEEF5;
        }
        cursor: pointer;
        &:hover {
            background-color: #f5f7fa;
        }
        .title {
            width: 100%;
            font-size: var(--portalFontSize13);
            color: #333333;
            margin-bottom: 15px;
            // line-height: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            .icon {
                display: block;
                float: right;
                width: 30px;
            }
            .text {
                display: inline-block;
                width: calc(100% - 30px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .bottom {
            color: #9b9b9b;
            //   line-height: 25px;
            font-size: 0;
            font-family: MicrosoftYaHei;
            font-size: var(--portalFontSize12);
            display: flex;
            justify-content: space-between;
            width: 100%;
            .name1 {
                width: 75%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .time {
                display: block;
                width: 106px;
                float: right;
                margin-right: 10px;
                font-size: var(--portalFontSize12);
            }
            .sender {
                font-size: var(--portalFontSize12);
            }
            &:not(:last-child) {
                margin-bottom: 10px;
            }
        }
    }
}
</style>
